import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionIndicator,
  AccordionItem,
  AccordionTrigger
} from '~shared/components/accordion'
import { cn } from '~shared/utils/cn'
import { LOCALES } from '@/fractals/constants'
import { faqData } from '../const'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'

export interface FaqSectionProps {
  className?: string
}

export const FaqSection = (props: FaqSectionProps) => {
  const { className = '' } = props

  return (
    <section className={cn('container container-slim', className)}>
      <h2 className='typo-section-heading text-center'>Нас часто спрашивают</h2>
      <Accordion
        type='single'
        className='grid grid-cols-1 md:grid-cols-2 gap-2 lg:gap-4 mt-[30px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]'
        collapsible>
        {faqData.map(({ question, answer }) => (
          <AccordionItem
            key={question[LOCALES.ru]}
            value={question[LOCALES.ru]}
            className='bg-secondary self-start'>
            <AccordionHeader asChild>
              <div>
                <AccordionTrigger>
                  {question[LOCALES.ru]}
                  <AccordionIndicator />
                </AccordionTrigger>
              </div>
            </AccordionHeader>

            <AccordionContent>
              {replacePrepositionsWhitespaces(answer[LOCALES.ru])}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  )
}
